import { useState, useEffect } from "react";
import "../../../App.css";
import Listdelete from "./ListDelete";
import { useNavigate, useLocation } from "react-router-dom";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import HandleHttpErrors from "../../HandleHttpErrors";
import Add from "./Add";

const baseURL = process.env.REACT_APP_API_JOBS;
function Educations(props) {
  const { visible, moamad, hagsha_aharon, counter, setCounter } = props;
  const [eduOptions, setEduOptions] = useState();
  const axiosPrivate = useAxiosPrivate("application/json");
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();
    const getData = async () => {
      try {
        const response = await axiosPrivate.get(baseURL + "edutype/", {
          signal: controller.signal,
        });
        isMounted && setEduOptions(response.data[0].eduOptions);
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
    };

    getData();
  }, []);

  const increment = () => {
    setCounter(counter + 1);
  };

  if (!visible) return;
  return (
    <>
      <Add
        increment={increment}
        counter={counter}
        moamad={moamad}
        eduOptions={eduOptions}
        hagsha_aharon={hagsha_aharon}
      />
      <Listdelete
        increment={increment}
        counter={counter}
        setCounter={setCounter}
        moamad_id={moamad.id}
        eduOptions={eduOptions}
        moamad={moamad}
        hagsha_aharon={hagsha_aharon}
      />
    </>
  );
}

export default Educations;
